export const allCategoriesNavigationKey = 'all categories'
